// src/components/admin/scheduling/constants.js

export const DAYS_ORDER = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const DAY_META = {
  monday: {
    label: "Monday",
    titleBg: "#e06666",
    blockBg: "#fac0c0",
    emptyBg: "#fff6f6",
  },
  tuesday: {
    label: "Tuesday",
    titleBg: "#ffd966",
    blockBg: "#ffebb0",
    emptyBg: "#fffff1",
  },
  wednesday: {
    label: "Wednesday",
    titleBg: "#93c47d",
    blockBg: "#d9ead3",
    emptyBg: "#f7fff3",
  },
  thursday: {
    label: "Thursday",
    titleBg: "#6d9eeb",
    blockBg: "#c9daf8",
    emptyBg: "#f5f9ff",
  },
  friday: {
    label: "Friday",
    titleBg: "#76a5af",
    blockBg: "#d5e8ec",
    emptyBg: "#f5fdff",
  },
  saturday: {
    label: "Saturday",
    titleBg: "#8e7cc3",
    blockBg: "#d9d2e9",
    emptyBg: "#f4f1ff",
  },
  sunday: {
    label: "Sunday",
    titleBg: "#f6b26b",
    blockBg: "#ffe4c4",
    emptyBg: "#fff9f3",
  },
};

export const WEEKDAY_BLOCKS = [
  { id: "wk_300_350", label: "3:00 PM – 3:50 PM", startMin: 15 * 60, endMin: 15 * 60 + 50 },
  { id: "wk_400_550", label: "4:00 PM – 5:50 PM", startMin: 16 * 60, endMin: 17 * 60 + 50 },
  { id: "wk_600_755", label: "6:00 PM – 7:55 PM", startMin: 18 * 60, endMin: 19 * 60 + 55 },
];

export const SATURDAY_BLOCKS = [
  { id: "sa_900_1050", label: "9:00 AM – 10:50 AM", startMin: 9 * 60, endMin: 10 * 60 + 50 },
  { id: "sa_1105_1245", label: "11:05 AM – 12:45 PM", startMin: 11 * 60 + 5, endMin: 12 * 60 + 45 },
  { id: "sa_115_305", label: "1:15 PM – 3:05 PM", startMin: 13 * 60 + 15, endMin: 15 * 60 + 5 },
  { id: "sa_310_500", label: "3:10 PM – 5:00 PM", startMin: 15 * 60 + 10, endMin: 17 * 60 },
];

export const SESSION_STATUSES = ["Pending", "Confirmed", "Canceled", "No Show", "Present"];

export const SLOTS_PER_BLOCK = 3;
